import { UploadFile } from 'antd/es/upload'
import { useUploadMutation } from '../../store/api/upload-api'

export default function useUploadFiles() {
    const [upload, uploadState] = useUploadMutation()

    const uploadFiles = async (files: UploadFile<any>[]) => {
        const formData = new FormData()

        files.forEach(file => {
            if (file.originFileObj) formData.append('files', file.originFileObj)
        })

        return upload(formData)
    }

    return [uploadFiles, uploadState] as [typeof uploadFiles, typeof uploadState]
}
